<template>
    <div class="product-wrap">
        <div class="nav">
            <!-- 左侧分类菜单模块 -->
            <div class="left-menu">
                <div class="module-decor"></div>
                <div class="menu-header">
                    <div class="menu-title">产品分类</div>
                    <div class="menu-subtitle">PRODUCT CATEGORY</div>
                </div>
                <div class="menu-body">
                    <!-- 课程分类：平铺为一级菜单，不再下拉 -->
                    <div class="menu-item" v-for="cat in deduplicateSoftware" :key="cat.title"
                        :class="{ active: currType === 'software' && activeSubCategory === cat.title }"
                        @click="handleSoftwareCategoryClick(cat.title)">
                        <span class="menu-indicator"></span>
                        <span class="menu-label">{{ cat.title }}</span>
                        <span class="menu-count">{{ cat.count }}</span>
                    </div>

                    <!-- 实训设备一级菜单：原结构完全保留 -->
                    <div class="menu-item" :class="{ active: currType === 'hardware' }"
                        @click="handleTypeClick('hardware')">
                        <span class="menu-indicator"></span>
                        <span class="menu-label">实训设备</span>
                        <span class="menu-count">{{ hardwareTotal }}</span>
                        <span class="arrow-icon" :class="{ open: expandHardware }">▼</span>
                    </div>
                    <div class="sub-menu" v-show="expandHardware && currType === 'hardware'">
                        <div class="sub-item" v-for="cat in hardwarelisttware" :key="cat.title"
                            :class="{ active: activeSubCategory === cat.title }" @click="scrollToCategory(cat.title)">
                            {{ cat.title }}
                        </div>
                    </div>
                </div>
                <div class="menu-footer">
                    <div class="menu-divider"></div>
                    <div class="menu-tip">点击切换类型，点击分类快速定位</div>
                </div>
            </div>

            <!-- 右侧内容展示模块 -->
            <div class="right-content">
                <div class="content-header">
                    <div class="header-left">
                        <h2 class="header-title">{{ currType === 'software' ? '课程产品' : '实训设备' }}</h2>
                        <span class="header-badge">{{ totalProducts }} 个产品</span>
                    </div>
                    <div class="header-right">
                        <span class="header-hint">共 {{ showData.length }} 个分类</span>
                    </div>
                </div>

                <!-- 自动补位网格：分类块自动流动，卡片宽高完全不变 -->
                <div class="category-grid">
                    <div class="category-block" v-for="(category, index) in showData"
                        :key="`${category.title}-${index}`" :ref="el => setCategoryRef(category.title, el)"
                        :style="{ '--card-count': Math.min(category.list.length, 5) }">
                        <div class="card-grid">
                            <!-- 新增 active 动态类名，匹配当前激活分类 -->
                            <div class="product-card" v-for="item in category.list" :key="item.name"
                                :class="{ active: category.title === activeCategory }" @click="goProductDetail(item)">

                                <div style="display: flex; justify-content: center; align-items: center; ">

                                    <div class="title">{{ category.title }}</div>

                                    <div class="card-photo">
                                        <div class="card-overlay"></div>
                                        <!-- <img class="default-img" :src="item.img" alt="产品图" loading="lazy"
                                            @error="imgLoadErr($event, item.name, '默认图')" /> -->
                                        <img class="hover-img" :src="item.hoverImg" alt="悬浮图" loading="lazy"
                                            @error="imgLoadErr($event, item.name, '悬浮图')" />
                                    </div>
                                </div>

                                <div class="card-info">
                                    <div class="card-name">{{ item.name }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import baseImg from '@/assets/employ/new-1.png'

import deviceCTimg from '@/assets/dCT5.png'
import deviceDRimg from '@/assets/dDR4.png'
import deviceMRIimg from '@/assets/dMRI1.png'

import perCTimg from '@/assets/pCT1.png'
import perDRimg from '@/assets/pDR2.png'
import perMRIimg from '@/assets/pMRI2.png'

import checkCTimg from '@/assets/cCT8.png'
import checkDRimg from '@/assets/cDR9.png'
import checkMRIimg from '@/assets/cMRI2.png'

import vrimg from '@/assets/vr_big.png'
import pacsimg from '@/assets/pacs.png'
import courseimg from '@/assets/course3.png'
import atlasimg from '@/assets/atlas.jpg'

import CTimg from '@/assets/hardCT1.png'
import DRimg from '@/assets/hardDR2.png'
import MRIimg from '@/assets/hardMRI1.png'

import dieBodyimg from '@/assets/newModel/Body-13.jpg'
import dieBodyUSimg from '@/assets/newModel/torsoScaled1.jpg'
import handleimg from '@/assets/handle2.png'
import supersoundimg from '@/assets/supersound1.png'

import desktopimg from '@/assets/image/d3.jpg'

import animalsimg from '@/assets/phantom/animals1.png'
import childrenimg from '@/assets/phantom/children6.jpg'
import geometryimg from '@/assets/phantom/geometry6.png'

export default {
    name: 'ProductCardShow',
    data() {
        return {
            currType: 'software',
            expandHardware: false,
            categoryRefMap: {},
            activeCategory: '', // 当前激活的分类标题
            activeSubCategory: '', // 当前选中的左侧子分类标题
            // 课程分类 - 按类属重组
            softwareList: [
                {
                    title: '医学影像设备学',
                    list: [
                        { name: 'MRI设备结构虚拟仿真系统', img: baseImg, hoverImg: deviceMRIimg, routeName: 'deviceMRI' },
                        { name: 'CT设备结构虚拟仿真系统', img: baseImg, hoverImg: deviceCTimg, routeName: 'deviceCT' },
                        { name: 'DR设备结构虚拟仿真系统', img: baseImg, hoverImg: deviceDRimg, routeName: 'deviceDR' },
                    ]
                },
                {
                    title: '医学影像设备学',
                    list: [
                        { name: 'MRI性能检测虚拟仿真系统', img: baseImg, hoverImg: perMRIimg, routeName: 'perMRI' },
                        { name: 'CT性能检测虚拟仿真系统', img: baseImg, hoverImg: perCTimg, routeName: 'perCT' },
                        { name: 'DR性能检测虚拟仿真系统', img: baseImg, hoverImg: perDRimg, routeName: 'perDR' }
                    ]
                },
                {
                    title: '医学影像检查技术学',
                    list: [
                        { name: 'MRI检查技术虚拟仿真系统', img: baseImg, hoverImg: checkMRIimg, routeName: 'checkMRI' },
                        { name: 'CT检查技术虚拟仿真系统', img: baseImg, hoverImg: checkCTimg, routeName: 'checkCT' },
                        { name: 'DR检查技术虚拟仿真系统', img: baseImg, hoverImg: checkDRimg, routeName: 'checkDR' }
                    ]
                },
                {
                    title: '医学影像学导论',
                    list: [
                        { name: '医学影像中心VR系统', img: baseImg, hoverImg: vrimg, routeName: 'vr' }
                    ]
                },
                {
                    title: '医学影像诊断学',
                    list: [
                        { name: '医学影像诊断思维教学系统', img: baseImg, hoverImg: pacsimg, routeName: 'pacs' }
                    ]
                },
                {
                    title: '医学图像处理',
                    list: [
                        { name: '医学图像处理教学系统', img: baseImg, hoverImg: courseimg, routeName: 'course' }
                    ]
                },
                {
                    title: '医学影像解剖学',
                    list: [
                        { name: '医学影像解剖图谱', img: baseImg, hoverImg: atlasimg, routeName: 'dissect' }
                    ]
                }
            ],
            // 实训设备分类
            hardwareList: [
                {
                    title: '教学实训设备',
                    list: [
                        { name: 'MRI教学实训设备', img: baseImg, hoverImg: MRIimg, routeName: 'MRI' },
                        { name: 'CT教学实训设备', img: baseImg, hoverImg: CTimg, routeName: 'CT' },
                        { name: 'DR教学实训设备', img: baseImg, hoverImg: DRimg, routeName: 'DR' }
                    ]
                },
                {
                    title: '医学人体模型',
                    list: [
                        { name: 'X线、CT、MRI人体模型', img: baseImg, hoverImg: dieBodyimg, routeName: 'dieBody' },
                        { name: 'X线、CT、超声人体模型', img: baseImg, hoverImg: dieBodyUSimg, routeName: 'dieBodyUS' }
                    ]
                },
                {
                    title: '三维影像后处理系统',
                    list: [
                        { name: '三维影像后处理系统', img: baseImg, hoverImg: handleimg, routeName: 'handle' }
                    ]
                },
                {
                    title: '超声教学实训设备',
                    list: [
                        { name: '超声教学实训设备', img: baseImg, hoverImg: supersoundimg, routeName: 'supersound' }
                    ]
                },
                {
                    title: '桌面式教学机',
                    list: [
                        { name: '桌面式教学机', img: baseImg, hoverImg: desktopimg, routeName: 'desktop' }
                    ]
                },
                {
                    title: '实训体模',
                    list: [
                        { name: '医学儿童模型', img: baseImg, hoverImg: childrenimg, routeName: 'children'},
                        { name: '医学兽医模型', img: baseImg, hoverImg: animalsimg, routeName: 'animals'},
                    ]
                },
                {
                    title: '实训体模',
                    list: [
                        { name: '医学几何模型', img: baseImg, hoverImg: geometryimg, routeName: 'geometry'},
                    ]
                },
            ]
        }
    },
    computed: {
        showData() {
            return this.currType === 'software' ? this.softwareList : this.hardwareList
        },
        softwareTotal() {
            return this.softwareList.reduce((acc, cur) => acc + cur.list.length, 0)
        },
        hardwareTotal() {
            return this.hardwareList.reduce((acc, cur) => acc + cur.list.length, 0)
        },
        totalProducts() {
            return this.currType === 'software' ? this.softwareTotal : this.hardwareTotal
        },
        //标题去重
        deduplicateSoftware() {
            const countMap = {}
            // 统计每个分类标题对应的产品总数
            this.softwareList.forEach(item => {
                if (!countMap[item.title]) {
                    countMap[item.title] = 0
                }
                countMap[item.title] += item.list.length
            })
            // 转成数组格式，去重并携带数量
            return Object.keys(countMap).map(title => ({
                title,
                count: countMap[title]
            }))
        },
        hardwarelisttware() {
            const centMap = {}
            // 统计每个分类标题对应的产品总数
            this.hardwareList.forEach(item => {
                if (!centMap[item.title]) {
                    centMap[item.title] = 0
                }
                centMap[item.title] += item.list.length
            })
            // 转成数组格式，去重并携带数量
            return Object.keys(centMap).map(title => ({
                title,
                count: centMap[title]
            }))
        },
    },
    methods: {
        imgLoadErr(e, name, type) {
            console.error(`【${name}】${type}图片加载失败，请检查assets路径`, e.target.src)
        },
        goProductDetail(item) {
            this.$router.push({ name: item.routeName })
        },
        // 实训设备一级菜单切换（原逻辑保留，仅移除软件相关展开）
        handleTypeClick(type) {
            this.currType = type
            this.activeCategory = '' // 切换大类时清空右侧激活状态
            this.activeSubCategory = '' // 切换大类时清空左侧子分类选中
            if (type === 'hardware') {
                this.expandHardware = !this.expandHardware
            }
            this.categoryRefMap = {}
            this.$nextTick(() => {
                document.querySelector('.right-content').scrollTop = 0
            })
        },
        // 课程分类一级菜单点击：切换大类 + 滚动定位
        handleSoftwareCategoryClick(title) {
            this.currType = 'software'
            this.expandHardware = false // 点击课程时自动收起实训设备下拉
            this.$nextTick(() => {
                this.scrollToCategory(title)
            })
        },
        // 收集DOM引用（修改后）
        setCategoryRef(title, el) {
            // 只保存第一个同标题的 DOM 引用，避免被覆盖
            if (el && !this.categoryRefMap[title]) {
                this.categoryRefMap[title] = el
            }
        },
        // 平滑滚动定位 + 设置激活状态
        scrollToCategory(title) {
            const targetDom = this.categoryRefMap[title]
            if (!targetDom) return
            targetDom.scrollIntoView({
                behavior: 'smooth',
                block: 'end'
            })
            this.activeCategory = title // 设置右侧卡片激活
            this.activeSubCategory = title // 设置左侧子分类选中高亮
        },
    }
}
</script>

<style scoped>
/* ========== 全局基础 ========== */
.product-wrap {
    width: 100%;
    min-height: 100vh;
    padding: 40px 16px;
    background: radial-gradient(ellipse at 10% 20%, #f5f9ff 0%, #e8f0fe 50%, #f0f6ff 100%);
    box-sizing: border-box;
    position: relative;
}

.product-wrap::before {
    content: '';
    position: absolute;
    top: -10%;
    right: -5%;
    width: 40%;
    height: 60%;
    background: radial-gradient(circle at 70% 30%, rgba(43, 120, 228, 0.04), transparent 70%);
    pointer-events: none;
}

.nav {
    width: 94%;
    max-width: 1920px;
    margin: 0 auto;
    display: flex;
    gap: 28px;
    align-items: flex-start;
    position: relative;
    z-index: 1;
}

/* ========== 左侧分类菜单 ========== */
.left-menu {
    flex: 0 0 230px;
    background: rgba(255, 255, 255, 0.85);
    backdrop-filter: blur(12px);
    -webkit-backdrop-filter: blur(12px);
    border-radius: 20px;
    box-shadow: 0 20px 40px -12px rgba(25, 60, 120, 0.12), 0 1px 4px rgba(25, 60, 120, 0.04);
    position: sticky;
    top: 20px;
    border: 1px solid rgba(255, 255, 255, 0.6);
    position: relative;
    max-height: calc(100vh - 40px);
    overflow-y: auto;
    transition: box-shadow 0.3s ease;
}

.left-menu:hover {
    box-shadow: 0 24px 48px -12px rgba(25, 60, 120, 0.18), 0 1px 4px rgba(25, 60, 120, 0.06);
}

.left-menu::-webkit-scrollbar {
    width: 4px;
}

.left-menu::-webkit-scrollbar-track {
    background: transparent;
}

.left-menu::-webkit-scrollbar-thumb {
    background: #d0dceb;
    border-radius: 4px;
}

.module-decor {
    width: 100%;
    height: 4px;
    background: linear-gradient(90deg, #1a6bd4, #63a4ff, #a0c8ff);
    border-radius: 0 0 4px 4px;
}

.menu-header {
    padding: 24px 20px 18px;
    background: linear-gradient(180deg, rgba(247, 250, 255, 0.6) 0%, transparent 100%);
    border-bottom: 1px solid rgba(238, 242, 248, 0.6);
}

.menu-title {
    font-size: 18px;
    font-weight: 700;
    color: #0a1a33;
    letter-spacing: 0.5px;
    line-height: 1.3;
    background: linear-gradient(135deg, #0a1a33, #1a6bd4);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
}

.menu-subtitle {
    font-size: 10px;
    font-weight: 600;
    color: #a8b8cc;
    letter-spacing: 2.5px;
    margin-top: 4px;
    text-transform: uppercase;
}

.menu-body {
    padding: 12px 14px 8px;
}

.menu-item {
    position: relative;
    padding: 12px 0;
    margin-bottom: 6px;
    border-radius: 12px;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    color: #5b6d85;
    display: flex;
    align-items: center;
    gap: 12px;
    font-weight: 500;
    border: 1px solid transparent;
    background: transparent;
    text-align: left;
}

.menu-item:last-child {
    margin-bottom: 0;
}

.menu-indicator {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #d5deeb;
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    flex-shrink: 0;
}

.menu-label {
    flex: 1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-weight: 500;
}

.menu-count {
    font-size: 11px;
    font-weight: 600;
    color: #9aacbf;
    background: rgba(240, 244, 249, 0.8);
    padding: 2px 10px;
    border-radius: 12px;
    transition: all 0.3s ease;
    flex-shrink: 0;
    backdrop-filter: blur(4px);
}

.arrow-icon {
    font-size: 11px;
    color: #b0c0d3;
    transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    flex-shrink: 0;
}

.arrow-icon.open {
    transform: rotate(180deg);
    color: #1a6bd4;
}

.sub-menu {
    padding: 4px 8px 8px 32px;
}

.sub-item {
    padding: 8px 12px;
    margin: 2px 0;
    font-size: 13px;
    color: #5e7a9a;
    cursor: pointer;
    border-radius: 8px;
    transition: all 0.25s ease;
    line-height: 1.4;
    font-weight: 450;
    position: relative;
    text-align: left;
}

.sub-item::before {
    content: '';
    position: absolute;
    left: -8px;
    top: 50%;
    transform: translateY(-50%);
    width: 3px;
    height: 3px;
    border-radius: 50%;
    background: #d5deeb;
    transition: all 0.3s ease;
}

/* hover + 选中激活 共用效果 */
.sub-item:hover,
.sub-item.active {
    background: rgba(43, 120, 228, 0.08);
    color: #1a6bd4;
    transform: translateX(4px);
}

.sub-item:hover::before,
.sub-item.active::before {
    background: #1a6bd4;
    width: 4px;
    height: 4px;
}

.menu-item:hover:not(.active) {
    background: rgba(43, 120, 228, 0.06);
    color: #1a6bd4;
    transform: translateX(3px);
    border-color: rgba(43, 120, 228, 0.08);
}

.menu-item:hover:not(.active) .menu-indicator {
    background: #1a6bd4;
    transform: scale(1.5);
    box-shadow: 0 0 0 4px rgba(43, 120, 228, 0.1);
}

.menu-item:hover:not(.active) .menu-count {
    background: rgba(43, 120, 228, 0.1);
    color: #1a6bd4;
}

.menu-item.active {
    background: linear-gradient(135deg, rgba(43, 120, 228, 0.12), rgba(43, 120, 228, 0.04));
    color: #0f4b8a;
    font-weight: 600;
    border-color: rgba(43, 120, 228, 0.15);
    box-shadow: 0 4px 12px rgba(43, 120, 228, 0.06);
}

.menu-item.active .menu-indicator {
    background: linear-gradient(135deg, #1a6bd4, #4a94ec);
    width: 8px;
    height: 8px;
    box-shadow: 0 0 0 5px rgba(43, 120, 228, 0.1);
}

.menu-item.active .menu-count {
    background: linear-gradient(135deg, #1a6bd4, #4a94ec);
    color: #fff;
    box-shadow: 0 2px 8px rgba(43, 120, 228, 0.2);
}

.menu-footer {
    padding: 16px 20px 20px;
    border-top: 1px solid rgba(238, 242, 248, 0.6);
    margin-top: 4px;
}

.menu-divider {
    width: 32px;
    height: 2px;
    background: linear-gradient(90deg, #dce3ed, transparent);
    border-radius: 2px;
    margin-bottom: 10px;
}

.menu-tip {
    font-size: 11px;
    color: #b5c3d4;
    letter-spacing: 0.2px;
    font-weight: 400;
    line-height: 1.5;
}

/* ========== 右侧产品展示 ========== */
.right-content {
    flex: 1;
    min-width: 0;
    background: rgba(255, 255, 255, 0.85);
    backdrop-filter: blur(12px);
    -webkit-backdrop-filter: blur(12px);
    border-radius: 20px;
    box-shadow: 0 20px 40px -12px rgba(25, 60, 120, 0.08), 0 1px 4px rgba(25, 60, 120, 0.03);
    padding: 32px 36px;
    box-sizing: border-box;
    border: 1px solid rgba(255, 255, 255, 0.6);
    margin-top: 20px;
    transition: box-shadow 0.3s ease;
}

.right-content:hover {
    box-shadow: 0 24px 48px -12px rgba(25, 60, 120, 0.12), 0 1px 4px rgba(25, 60, 120, 0.05);
}

.content-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 18px;
    margin-bottom: 30px;
    border-bottom: 2px solid rgba(43, 120, 228, 0.06);
}

.header-left {
    display: flex;
    align-items: center;
    gap: 16px;
}

.header-title {
    font-size: 26px;
    font-weight: 700;
    letter-spacing: -0.5px;
    margin: 0;
    background: linear-gradient(135deg, #0a1a33, #1a6bd4);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    position: relative;
}

.header-title::after {
    content: '';
    position: absolute;
    bottom: -4px;
    left: 0;
    width: 40px;
    height: 3px;
    background: linear-gradient(90deg, #1a6bd4, transparent);
    border-radius: 2px;
    opacity: 0.3;
}

.header-badge {
    font-size: 12px;
    font-weight: 600;
    color: #1a6bd4;
    background: rgba(43, 120, 228, 0.08);
    padding: 4px 14px;
    border-radius: 20px;
    border: 1px solid rgba(43, 120, 228, 0.08);
    backdrop-filter: blur(4px);
}

.header-right {
    display: flex;
    align-items: center;
}

.header-hint {
    font-size: 12px;
    color: #9aabbe;
    letter-spacing: 0.4px;
    font-weight: 450;
    background: rgba(240, 244, 249, 0.5);
    padding: 4px 14px;
    border-radius: 20px;
}

/* ========== 核心：自动补位网格 ========== */
.category-grid {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    column-gap: 18px;
    row-gap: 36px;
    grid-auto-flow: dense;
    align-items: start;
}

.category-block {
    grid-column: span var(--card-count);
    display: flex;
    flex-direction: column;
    gap: 18px;
    min-width: 0;
}

/* 分类内卡片网格 */
.card-grid {
    display: grid;
    grid-template-columns: repeat(var(--card-count), 1fr);
    gap: 18px;
}

/* ========== 产品卡片 ========== */
.product-card {
    flex: 1;
    background: #ffffff;
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03), 0 1px 2px rgba(0, 0, 0, 0.01);
    transition: all 0.4s cubic-bezier(0.2, 0.8, 0.3, 1);
    display: flex;
    flex-direction: column;
    cursor: pointer;
    border: 1px solid rgba(240, 243, 248, 0.8);
    min-width: 0;
    position: relative;
    will-change: transform;
}

.product-card::before {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: 16px;
    padding: 1px;
    background: linear-gradient(135deg, transparent 40%, rgba(43, 120, 228, 0.03) 100%);
    -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    mask-composite: exclude;
    pointer-events: none;
}

/* hover 和 active 共用全套悬浮效果 */
.product-card:hover,
.product-card.active {
    box-shadow: 0 16px 40px -8px rgba(43, 120, 228, 0.12), 0 4px 16px rgba(43, 120, 228, 0.04);
    transform: translateY(-6px);
    border-color: rgba(43, 120, 228, 0.12);
    background: #fbfdff;
}

.product-card:active {
    transform: translateY(-2px) scale(0.99);
}

.card-photo {
    position: relative;
    width: 100%;
    height: 150px;
    background: #f8faff;
    overflow: hidden;
    padding: 0 10px;
}

.card-photo::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 35%;
    background: linear-gradient(0deg, rgba(0, 0, 0, 0.02), transparent);
    pointer-events: none;
    z-index: 1;
}

.card-overlay {
    position: absolute;
    inset: 0;
    background: linear-gradient(135deg, rgba(43, 120, 228, 0.04), rgba(43, 120, 228, 0.10));
    opacity: 0;
    transition: opacity 0.4s ease;
    z-index: 2;
}

/* hover 和 active 共用遮罩显示 */
.product-card:hover .card-overlay,
.product-card.active .card-overlay {
    opacity: 1;
}

.title {
    height: 20px;
    padding: 2px 9px;
    text-align: center;
    line-height: 20px;
    font-size: 11px;
    position: absolute;
    top: 8px;
    right: 12px;
    background: linear-gradient(135deg, #1a6bd4, #3a8aec);
    z-index: 999;
    border: none;
    border-radius: 12px;
    color: #ffffff;
    font-weight: 600;
    letter-spacing: 0.3px;
    box-shadow: 0 2px 8px rgba(26, 107, 212, 0.2);
    transition: all 0.35s ease;
    backdrop-filter: blur(4px);
}

/* hover 和 active 共用分类标签隐藏 */
.product-card:hover .title,
.product-card.active .title {
    opacity: 0;
    transform: translateY(-4px) scale(0.9);
}

/* 图片样式重写 */
.hover-img {
    position: absolute;
    width: 100%;
    height: 100%;
    object-fit: cover;
    left: 0;
    top: 0;
    padding: 0;
    transition: transform 0.8s cubic-bezier(0.2, 0.8, 0.3, 1);
    /* 默认状态基础缩放 */
    transform: scale(0.92);
}

/* hover / active 放大效果 */
.product-card:hover .hover-img,
.product-card.active .hover-img {
    transform: scale(1.08);
}

/* 图片完全铺满 */
/* .default-img,
.hover-img {
    position: absolute;
    width: 100%;
    height: 100%;
    object-fit: cover;
    left: 0;
    top: 0;
    padding: 0;
    transition: transform 0.8s cubic-bezier(0.2, 0.8, 0.3, 1), opacity 0.5s ease-in-out;
} */

/* .default-img {
    opacity: 1;
    transform: scale(0.92);
} */

/* .hover-img {
    opacity: 0;
    transform: scale(0.92);
} */

/* hover 和 active 共用默认图切换 */
/* .product-card:hover .default-img,
.product-card.active .default-img {
    opacity: 0;
    transform: scale(1.05);
} */

/* hover 和 active 共用悬浮图显示 */
/* .product-card:hover .hover-img,
.product-card.active .hover-img {
    opacity: 1;
    transform: scale(1);
} */

.card-info {
    padding: 12px 14px 14px;
    display: flex;
    flex-direction: column;
    gap: 4px;
    background: #ffffff;
    transition: background 0.3s ease;
}

/* hover 和 active 共用信息区背景 */
.product-card:hover .card-info,
.product-card.active .card-info {
    background: #fbfdff;
}

.card-name {
    font-size: 13px;
    font-weight: 500;
    color: #1a2a44;
    line-height: 1.5;
    transition: color 0.3s ease;
    word-break: break-all;
}

/* 悬浮时名称颜色：原有深蓝色 */
.product-card:hover .card-name {
    color: #1a6bd4;
}

/* 选中激活时名称颜色：单独设置浅蓝 */
.product-card.active .card-name {
    color: #2563AF;
}

/* ========== 响应式适配 ========== */
@media (max-width: 1600px) {
    .category-grid {
        grid-template-columns: repeat(5, 1fr);
    }
}

@media (max-width: 1400px) {
    .nav {
        width: 96%;
        gap: 22px;
    }

    .left-menu {
        flex: 0 0 210px;
    }

    .right-content {
        padding: 28px 30px;
    }

    .category-grid {
        grid-template-columns: repeat(4, 1fr);
    }

    .card-photo {
        height: 100px;
    }
}

@media (max-width: 1100px) {
    .category-grid {
        grid-template-columns: repeat(3, 1fr);
    }

    .card-photo {
        height: 95px;
    }
}

@media (max-width: 900px) {
    .nav {
        flex-direction: column;
        width: 98%;
        gap: 16px;
    }

    .left-menu {
        flex: 1 1 auto;
        width: 100%;
        position: static;
        max-height: unset;
        backdrop-filter: blur(8px);
    }

    .menu-body {
        display: flex;
        flex-wrap: wrap;
        gap: 6px;
        padding: 10px 12px;
    }

    .menu-item {
        flex: 1 1 42%;
        min-width: 130px;
        margin-bottom: 0;
        padding: 10px 14px;
    }

    .sub-menu {
        width: 100%;
        flex: 1 1 100%;
        padding-left: 16px;
        padding-top: 2px;
    }

    .menu-footer {
        display: none;
    }

    .right-content {
        padding: 24px 22px;
        margin-top: 0;
    }

    .content-header {
        flex-direction: column;
        align-items: flex-start;
        gap: 10px;
        padding-bottom: 14px;
    }

    .category-grid {
        grid-template-columns: repeat(3, 1fr);
        row-gap: 28px;
        column-gap: 14px;
    }

    .card-photo {
        height: 90px;
    }
}

@media (max-width: 680px) {
    .category-grid {
        grid-template-columns: repeat(2, 1fr);
    }

    .card-photo {
        height: 100px;
    }
}

@media (max-width: 560px) {
    .product-wrap {
        padding: 20px 10px;
    }

    .right-content {
        padding: 18px 14px;
        border-radius: 16px;
    }

    .header-title {
        font-size: 20px;
    }

    .header-title::after {
        width: 28px;
    }

    .category-grid {
        grid-template-columns: 1fr 1fr;
        column-gap: 10px;
        row-gap: 20px;
    }

    .card-grid {
        gap: 12px;
    }

    .card-photo {
        height: 85px;
    }

    .card-info {
        padding: 8px 10px 10px;
    }

    .card-name {
        font-size: 12px;
    }

    .menu-item {
        flex: 1 1 100%;
        padding: 10px 12px;
    }

    .menu-title {
        font-size: 16px;
    }

    .header-badge,
    .header-hint {
        font-size: 11px;
        padding: 3px 10px;
    }

    .title {
        width: 70px;
        font-size: 10px;
        height: 18px;
        line-height: 18px;
        top: 8px;
        right: 8px;
    }
}
</style>